import _ from "lodash";
import FieldNames from "../defaults/FieldNames.json";
import ActionCategoryAssociations from '../defaults/ActionCategoryAssociations.json'

export function getByClassEntityTypeJoinFeature(attributes, categoryAssociationField) {
  let classValues;
  let joinFeatureValues;
  let entityTypeValues;
  let programTypeValues;
  //Get the object for the correct Class, Join Feature, and Entity Type then return any categories that are similar between the 2 of them
  if(attributes?.[FieldNames.featureFields.class] === FieldNames.classTypes.treatment || attributes?.[FieldNames.featureFields.class] === FieldNames.classTypes.actualTreatment){
    classValues = ActionCategoryAssociations?.[FieldNames.categoryClassTypes.treatment]?.[categoryAssociationField]
  } else {
    classValues = ActionCategoryAssociations?.[FieldNames.categoryClassTypes.activity]?.[categoryAssociationField]
  }

  if(attributes?.[FieldNames.featureFields.joinFeature] === FieldNames.joinFeatureValues.polygon){
    joinFeatureValues = ActionCategoryAssociations?.[FieldNames.joinFeatureValues.polygon]?.[categoryAssociationField]
  } else if(attributes?.[FieldNames.featureFields.joinFeature] === FieldNames.joinFeatureValues.line) {
    joinFeatureValues = ActionCategoryAssociations?.[FieldNames.joinFeatureValues.line]?.[categoryAssociationField]
  } else {
    joinFeatureValues = ActionCategoryAssociations?.[FieldNames.joinFeatureValues.point]?.[categoryAssociationField]
  }

  if(attributes?.[FieldNames.featureFields.entityType] === FieldNames.internalEntityTypes.postFire){
    entityTypeValues = ActionCategoryAssociations?.[FieldNames.internalEntityTypes.postFire]?.[categoryAssociationField]
  } else {
    entityTypeValues = ActionCategoryAssociations?.[FieldNames.internalEntityTypes.fuels]?.[categoryAssociationField]
  }

  if(attributes?.[FieldNames.featureFields.program] === FieldNames.programTypes.es && attributes?.[FieldNames.featureFields.entityType] === FieldNames.internalEntityTypes.postFire){
    programTypeValues = ActionCategoryAssociations?.[FieldNames.programTypes.es]?.[categoryAssociationField]
  } else if(attributes?.[FieldNames.featureFields.program] === FieldNames.programTypes.bar && attributes?.[FieldNames.featureFields.entityType] === FieldNames.internalEntityTypes.postFire){
    programTypeValues = ActionCategoryAssociations?.[FieldNames.programTypes.bar]?.[categoryAssociationField]
  }

  let arrays = []
  if(classValues?.length > 0){
    arrays.push(classValues)
  }

  if(joinFeatureValues?.length > 0){
    arrays.push(joinFeatureValues)
  }

  if(entityTypeValues?.length > 0){
    arrays.push(entityTypeValues)
  }

  if(programTypeValues?.length > 0){
    arrays.push(programTypeValues)
  }
  
  //Go through each and find only options that are the same between all arrays
  let finalItems = arrays?.flat();
  if(arrays?.length > 1) {
    finalItems = arrays.reduce((p,c) => p.filter(e => c.includes(e)))
  } 

  return finalItems
}

export function getByLevel(attributes, categoryAssociationField){
  if(!attributes)
  {
    return [];
  }
  let selectedParentValue = ""
  let selectedParentField = "";
  if(categoryAssociationField === FieldNames.categoryAssociationFields.categories){
    selectedParentValue = attributes[FieldNames.featureFields.program]
    selectedParentField = FieldNames.categoryAssociationFields.programs
  } else if(categoryAssociationField === FieldNames.categoryAssociationFields.types){
    selectedParentValue = attributes[FieldNames.featureFields.category]
    selectedParentField = FieldNames.categoryAssociationFields.categories
  } else if(categoryAssociationField === FieldNames.categoryAssociationFields.subTypes){
    selectedParentValue = attributes[FieldNames.featureFields.type]
    selectedParentField = FieldNames.categoryAssociationFields.types
  } else if(categoryAssociationField === FieldNames.categoryAssociationFields.measurements){
    selectedParentValue = attributes[FieldNames.featureFields.subType] ? attributes[FieldNames.featureFields.subType] : attributes[FieldNames.featureFields.type]
    selectedParentField = attributes[FieldNames.featureFields.subType] ? FieldNames.categoryAssociationFields.subTypes : FieldNames.categoryAssociationFields.types
  }

  //This will get every possible option by class, entity type, and join feature for the level you are looking for
  //ie Treatment, Post Fire, Polygon
  const byTopLevel = getByClassEntityTypeJoinFeature(attributes, categoryAssociationField);
  let arrays = []
  if(byTopLevel?.length > 0){
    arrays.push(byTopLevel)
  }

  //Go find one level up from what we are trying to find.  If we want the type options go find the category list for the selected category and grab all of those types
  const optionsByCategoryAssociationField = ActionCategoryAssociations?.[selectedParentField]?.[selectedParentValue]?.[categoryAssociationField]
  //Adding so that if it comes back as an empty array we will filter out everthing with reduce below
  if(categoryAssociationField === FieldNames.categoryAssociationFields.subTypes){
    arrays.push(optionsByCategoryAssociationField)
  } else {
    if(optionsByCategoryAssociationField?.length > 0){
      arrays.push(optionsByCategoryAssociationField)
    }
  }
  

  //Exclude all options that aren't in both arrays for a final list
  let finalItems = arrays?.flat();
  if(arrays?.length > 1) {
    finalItems = arrays?.reduce((p,c) => p?.filter(e => c?.includes(e)))
  } 

  return finalItems
}